module.exports = __webpack_public_path__ + "static/media/dose-reference-levels-fluoroscopy-angiography.319c6f5e.svg";